/** CSS custom properties for report / chart-library data tables — see `index.css` `.report-data-table` */

export const REPORT_TABLE_CSS_VARS = {
    fontSize: '--report-table-font-size',
    headerFontSize: '--report-table-header-font-size',
    lineHeight: '--report-table-line-height',
    cellPaddingX: '--report-table-cell-px',
    cellPaddingY: '--report-table-cell-py',
    headerBg: '--report-table-header-bg',
    borderColor: '--report-table-border-color',
    headerText: '--report-table-header-text',
    bodyText: '--report-table-body-text',
} as const;

/** Root scope for report tables — paired with `styles/reportTable.css` (loads last) */
export const DATA_TABLE_CHART_REPORT_CLASS = 'data-table-chart-report';

/** Wrapper class applied to report-variant tables (DataTableChart + Table `report`) */
export const REPORT_TABLE_WRAPPER_CLASS = 'report-data-table';

export const REPORT_TABLE_CELL_CLASS = {
    primary: 'report-table-cell--primary',
    strong: 'report-table-cell--strong',
    numeric: 'report-table-cell--numeric',
} as const;

export const REPORT_TABLE_HEADER_CELL_CLASS = 'report-table-header-cell';

/** Wraps table previews in Chart Library cards (Settings + /chart-library) */
export const CHART_LIBRARY_TABLE_CLASS = 'chart-library-table';

/** Tailwind 14px on cells — `!` beats parent `text-base` / body 16px inheritance */
export const REPORT_TABLE_TEXT_CLASS = '!text-sm';

/** Tailwind 12px on headers */
export const REPORT_TABLE_HEADER_TEXT_CLASS = '!text-xs';

/** Dedicated class — see end of `index.css` */
export const REPORT_TABLE_FONT_CLASS = 'report-table-font-14';

/** Inline fallback so cells are 14px even if stylesheet order loses */
export const REPORT_TABLE_CELL_FONT_STYLE = {
    fontSize: '14px',
    lineHeight: '1.25',
} as const;

export const REPORT_TABLE_HEADER_CELL_FONT_STYLE = {
    fontSize: '12px',
    lineHeight: '1.25',
} as const;

export const reportTableRootStyle = REPORT_TABLE_CELL_FONT_STYLE;
